const brandSkeleton = {
    saleId: null,
    name: null,
    site: null,
    countryId: null,
    groupId: null,
    parentId: null,
    dealerStatus: null,

    rating: null,
    efficiency: null,
    ruFrequency: null,
    wwFrequency: null,
    goodsNumber: null,
    pureArticles: null,
    brandTasks: null,
    lastDate: null,

    onOurSite: null,
    legalEntity: null,
    groupOfBrands: null,
    brandGroupWebsite: null,
    additionalBrandSites: null,
    ruFrequencyStatus: null,
    wwFrequencyStatus: null,
    tags: null,
    transName: null,
    siteName: null,
    logo: null,
    pseudo_logos: null,

    productCount: null,
    articleCount: null,
    categoryCount: null,
    productCategoryCount: null,
    productDescription: null,
    productShortDescription: null,
    productCharacteristics: null,
    productPages: null,
    parentProductsCount: null,
    childProductsCount: null,
    productsShop: null,
    productsOnline: null,
    productsPurchasePrice: null,
    productsCompetitorPrice: null,
    productsCrmPrice: null,
    productsSupplierWarehouse: null,
    productsOwnWarehouse: null,
    productsLastOrderDate: null,
    productsPhotos: null,
    wwUpdateDate: null,
    ruUpdateDate: null,
    isOptimization: null,
    ruSearchQueries: {},
    wwSearchQueries: {},
    sumRuFrequency: null,
    sumWwFrequency: null,

    isB2C: null,
    isTopClients: null,
    brandDescriptions: []
}
export default {
    namespaced: true,
    state: {
        brand: brandSkeleton,
        brandStatistic: [],
        brandErrors: [],
        groupList: [],
        countryList: [],
        brandList: [],
        commentList: [],
        isSendAlready: false,
        isBrandStatistic: false,
        isBrandErrors: false,
        haveChange: false,
    },
    getters: {
        HAVE_CHANGE: state => {
            return state.haveChange;
        },
        IS_SEND_ALREADY: state => {
            return state.isSendAlready;
        },
        IS_BRAND_STATISTIC: state => {
            return state.isBrandStatistic;
        },
        IS_BRAND_ERRORS: state => {
            return state.isBrandErrors;
        },
        BRAND: state => {
            return state.brand;
        },
        BRAND_STATISTIC: state => {
            return state.brandStatistic;
        },
        BRAND_ERRORS: state => {
            return state.brandErrors;
        },
        GROUP_LIST: state => {
            return state.groupList;
        },
        COUNTRY_LIST: state => {
            return state.countryList;
        },
        BRAND_LIST: state => {
            return state.brandList;
        },
        COMMENT_LIST: state => {
            return state.commentList;
        },
        SUM_RU_FREQUENCY: state => {
            return state.brand.sumRuFrequency;
        },
        SUM_WW_FREQUENCY: state => {
            return state.brand.sumWwFrequency;
        },
        RU_SEARCH_QUERIES: state => {
            return state.brand.ruSearchQueries;
        },
        WW_SEARCH_QUERIES: state => {
            return state.brand.wwSearchQueries;
        },
        WW_UPDATE_DATE: state => {
            return state.brand.wwUpdateDate;
        },
        RU_UPDATE_DATE: state => {
            return state.brand.ruUpdateDate;
        },

    },
    mutations: {
        HAVE_CHANGE: (state, payload) => {
            return state.haveChange = payload;
        },
        IS_SEND_ALREADY: (state, payload) => {
            return state.isSendAlready = payload;
        },
        IS_FULL_STATISTIC: (state, payload) => {
            return state.isBrandStatistic = payload;
        },
        IS_BRAND_ERRORS: (state, payload) => {
            return state.isBrandErrors = payload;
        },
        BRAND: (state, payload) => {
            return state.brand = payload;
        },
        BRAND_STATISTIC: (state, payload) => {
            return state.brandStatistic = payload;
        },
        BRAND_ERRORS: (state, payload) => {
            return state.brandErrors = payload;
        },
        GROUP_LIST: (state, payload) => {
            return state.groupList = payload;
        },
        COUNTRY_LIST: (state, payload) => {
            return state.countryList = payload;
        },
        BRAND_LIST: (state, payload) => {
            return state.brandList = payload;
        },
        COMMENT_LIST: (state, payload) => {
            return state.commentList = payload;
        },
        SUM_RU_FREQUENCY: (state, payload) => {
            return state.brand.sumRuFrequency = payload;
        },
        SUM_WW_FREQUENCY: (state, payload) => {
            return state.brand.sumWwFrequency = payload;
        },
        RU_SEARCH_QUERIES: (state, payload) => {
            return state.brand.ruSearchQueries = payload;
        },
        WW_SEARCH_QUERIES: (state, payload) => {
            return state.brand.wwSearchQueries = payload;
        },
        RU_UPDATE_DATE: (state, payload) => {
            return state.brand.ruUpdateDate = payload;
        },
        WW_UPDATE_DATE: (state, payload) => {
            return state.brand.wwUpdateDate = payload;
        },

    },
    actions: {
        GET_INFO: async ({commit}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-info/' + payload.id,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    console.log(responseData)
                    if (responseData.data.ruSearchQueries.length == 0) {
                        responseData.data.ruSearchQueries = {};
                    }
                    if (responseData.data.wwSearchQueries.length == 0) {
                        responseData.data.wwSearchQueries = {};
                    }
                    commit('BRAND', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        GET_STATISTIC: async ({commit}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-statistic/' + payload.id,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('BRAND_STATISTIC', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
                getError: () => {
                    commit('IS_FULL_STATISTIC', false);
                }
            });
        },
        GET_ERRORS: async ({commit}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-error/' + payload.id,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('BRAND_ERRORS', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
                getError: () => {
                    commit('IS_BRAND_ERRORS', false);
                }
            });
        },
        GET_GROUPS: async ({commit}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-group',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('GROUP_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        GET_COUNTRIES: async ({commit}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/country',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('COUNTRY_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        GET_BRANDS: async ({commit}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand?sort=saleId&sortDir=asc&page=1&pageSize=30',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('BRAND_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        GET_COMMENTS: async ({commit}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-comment/' + payload.brandId,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    // prepare message
                    let regex = new RegExp('\\n', 'g');
                    for (let key in responseData.data) {
                        responseData.data[key].message = responseData.data[key].message.replace(regex, '<br>')
                    }
                    commit('COMMENT_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        ADD_COMMENT: async ({dispatch}, payload) => {
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/brand-comment',
                parameter: {brandId: payload.brandId, message: payload.message},
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    if (responseData == 7) console.log(responseData);
                    payload.handleSuccessResponse();
                    dispatch('GET_COMMENTS', {
                        th: payload.th,
                        brandId: payload.brandId
                    });
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        SAVE: async ({state}, payload) => {
            console.log(state.brand)
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/brand-info/' + state.brand.saleId,
                parameter: state.brand,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    if (responseData == 7) console.log(responseData);
                    if (payload.handleSuccessResponse !== undefined) {
                        payload.handleSuccessResponse();
                    }
                    state.haveChange = false
                },
                getResponse: () => {
                    payload.th.showOverlay--;
                },
            });
        },
        FREQUENCY_UPDATE: async ({state, commit}, payload) => {
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/brand-info/frequency-update/' + state.brand.saleId,
                parameter: {type: payload.type},
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    if (responseData == 7) console.log(responseData);
                    let data = responseData.data;
                    if (payload.type == 'ru') {
                        commit('RU_SEARCH_QUERIES', data.frequencyList);
                        commit('SUM_RU_FREQUENCY', data.sum);
                        commit('RU_UPDATE_DATE', data.date);
                    } else {
                        commit('WW_SEARCH_QUERIES', data.frequencyList);
                        commit('SUM_WW_FREQUENCY', data.sum);
                        commit('WW_UPDATE_DATE', data.date);
                    }
                    // payload.th.$forceUpdate();
                    console.log(state.brand);
                },
                getResponse: () => {
                    // toggle button
                    payload.th.toggleButUpdate(payload.type)
                },
            });
        }

    }
}